import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth(); // make sure AuthContext exposes setUser
  const called = useRef(false);  // prevent double-call in React StrictMode

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const code = searchParams.get("code");
    const state = searchParams.get("state"); // role passed via state param
    const error = searchParams.get("error");

    if (error) {
      toast.error("Google login was cancelled or failed");
      navigate("/login");
      return;
    }

    if (!code) {
      toast.error("Invalid callback — no code received");
      navigate("/login");
      return;
    }

    const role = state || sessionStorage.getItem("apna_oauth_role") || "job_seeker";
    sessionStorage.removeItem("apna_oauth_role");

    api.post("/auth/google/callback", { code, role })
  .then(res => {
    const { user, token } = res.data;
    if (token) localStorage.setItem("apna_token", token);  // ← this was missing
    setUser(user);
    toast.success(`Welcome, ${user.name?.split(" ")[0]}!`);
    if (user.role === "super_admin") navigate("/superadmin");
    else if (user.role === "admin") navigate("/admin");
    else if (user.role === "job_poster") navigate("/dashboard/poster");
    else navigate("/dashboard/seeker");
  })
  .catch(err => {
    const msg = err?.response?.data?.detail || "Google login failed";
    toast.error(msg);
    navigate("/login");
  });
  }, []);

  return (
    <div className="min-h-screen grid place-items-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-4 border-[#1D6FF2] border-t-transparent rounded-full animate-spin" />
        <p className="text-slate-500 text-sm">Completing sign-in…</p>
      </div>
    </div>
  );
}